import { render, staticRenderFns } from "./PatientTabs.vue?vue&type=template&id=a634cdd0&scoped=true"
import script from "./PatientTabs.vue?vue&type=script&lang=js"
export * from "./PatientTabs.vue?vue&type=script&lang=js"
import style0 from "./PatientTabs.vue?vue&type=style&index=0&id=a634cdd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a634cdd0",
  null
  
)

export default component.exports